/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const orgCostCenter = {
  header: 'Todos los centros de coste ({{count}})',

  code: 'Código',
  active: 'Estado',
  name: 'Nombre',
  currency: 'Divisa',
  unit: 'Unidad para padres',
  actions: '',

  sortBy: 'Ordenar por',
  sort: {
    byName: 'Nombre',
    byUnitName: 'Unidad',
    byCode: 'Código',
  },

  hint: "Todos los pedidos realizados a través de la cuenta de compras de su organización están vinculados a un centro de costos con fines de seguimiento. Cada unidad puede tener varios centros de coste. Para limitar el gasto, los presupuestos se asignan a centros de coste. Un comprador selecciona un centro de coste al finalizar la compra.",
  disable: {
    confirm: 'Inutilizar',
  },

  messages: {
    deactivateTitle: 'Inutilizar this cost center?',
    deactivate:
      'Los centros de coste no utilizados no se pueden utilizar para realizar nuevos pedidos. Asegúrese de que su unidad tenga al menos un centro de costos. Los pedidos existentes no se ven afectados.',
    confirmEnabled: 'Centro de costos {{ item.name }} habilitado correctamente',
    confirmInutilizard: 'Centro de costes {{ item.name }} desactivado correctamente',
    update: 'Centro de coste {{ item.name }} actualizado con éxito',
    create: 'Centro de coste {{ item.name }} creado con éxito',
  },
  info: {
    disabledEdit: 'Habilite el centro de costos para permitir la edición.',
    disabledEnable:
      'Unidad debe estar habilitada antes de que se pueda habilitar este centro de costos.',
  },

  details: {
    title: 'Detalles del centro de coste',
    subtitle: 'Centro de coste: {{ item.name }}',
  },

  edit: {
    title: 'Editar centro de coste',
    subtitle: 'Centro de coste: {{ item.name }}',
  },

  create: {
    title: 'Crear centro de coste',
    subtitle: '',
  },

  budget: {
    link: 'Presupuestos',
  },

  breadcrumbs: {
    list: 'Todos los centros de coste',
    details: '{{name}}',
    budgets: 'Presupuestos',
  },
};

export const orgCostCenterAssignedBudgets = {
  title: 'Presupuestos asignados',
  subtitle: 'Centro de coste: {{ item.name }}',
  assigned: 'Presupuesto {{ item.name }} asignado con éxito',
  unassigned: 'Presupuesto {{ item.name }} sin asignar correctamente',
};

export const orgCostCenterBudgets = {
  title: 'Gestionar presupuestos',
  subtitle: 'Centro de coste: {{ item.name }}',
  assigned: 'Presupuesto {{ item.name }} asignado con éxito',
  unassigned: 'Presupuesto {{ item.name }} sin asignar correctamente',
};
